import React from "react";
import { makeStyles, Typography } from "@material-ui/core";

import { reinsuranceContent } from "../utils";

const Reassurance = ({ product }) => {
  const classes = useStyle();

  const content = reinsuranceContent(product);
  return (
    <ul className={classes.items__container}>
      {content.map(({ label, picto }) => {
        return (
          <li key={label}>
            {picto}
            <Typography variant="body2" color="secondary">
              {label}
            </Typography>
          </li>
        );
      })}
    </ul>
  );
};

export default Reassurance;
const useStyle = makeStyles((theme) => ({
  items__container: {
    padding: 0,
    "& li": {
      display: "flex",
      listStyle: "none",
      alignItems: "center",
      marginBottom: theme.spacing(2),
      "& svg": {
        marginRight: theme.spacing(2),
      },
    },
  },
}));
